import api from './api'

export default async (file, isPublic, type = 'upload', onProgress) => {
  const { name, size, type: mime } = file
  const signData = { name, mime, size, isPublic, type }

  return api.s3SignedPost(signData).then((signedParams) => (
    uploadFile(file, signedParams, onProgress)
  ))
}

const uploadFile = (file, signedParams, onProgress) => {
  const formData = new FormData()
  Object.entries(signedParams.signature).forEach(([k, v]) => formData.append(k, v))
  formData.append('file', file)

  const xhr = new XMLHttpRequest()
  xhr.responseType = 'document'
  xhr.withCredentials = false

  xhr.upload.addEventListener('progress', (e) => {
    if (!e.lengthComputable) return

    const total = e.total || 0
    const loaded = e.loaded || 0
    const perc = total ? loaded / total : 0
    if (onProgress) onProgress(perc, loaded, total)
  })

  return new Promise((resolve, reject) => {
    xhr.addEventListener('error', reject)
    xhr.addEventListener('abort', reject)

    xhr.addEventListener('load', () => {
      const res = xhr.response
      if (!res) return reject(new Error('No Response'))

      if (res.querySelector('Error')) {
        const reason = res.querySelector('Code').textContent + ': ' + res.querySelector('Message').textContent
        return reject(new Error(reason))
      }

      const url = res.querySelector('Location').textContent
      const key = res.querySelector('Key').textContent

      return url
        ? resolve({ default: url, url, key })
        : reject(new Error('NoLocation: No location in s3 POST response'))
    })

    xhr.open('POST', signedParams.postEndpoint, true)
    xhr.send(formData)
  })
}
